import Intercom from './Intercom'
export default Intercom
